import { useState, useEffect } from 'react';

function useStoredPermissions() {
  const [permissions, setPermissions] = useState(null);

  useEffect(() => {
    const storedPermissions = sessionStorage.getItem("permissions");
    if (storedPermissions) {
      try {
        setPermissions(JSON.parse(storedPermissions));
      } catch (e) {
        console.error("Error parsing permissions:", e);
        setPermissions([]);
      }
    }
  }, []);
  return permissions;
}

export default useStoredPermissions;
